import { RepairDocketStore } from '../repair-docket.store';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { WorkshopJobListStore } from './workshop-job-list.store.service';
import { ConfigService } from '../../shared/services/config.service';
import { Component, ElementRef, Input } from '@angular/core';
import { WorkshopJobService } from 'src/app/shared/services/workshop-job.service';
import { base64ToBlob } from 'src/app/shared/helpers/base64ToBlob';
import { timer } from 'rxjs';
import { CustomerEquipmentSelectComponent } from './customer-equipment-select/customer-equipment-select.component';
import { WorkshopJobsTableComponent } from './workshop-jobs-table/workshop-jobs-table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-workshop-jobs-list',
    templateUrl: './workshop-jobs-list.component.html',
    standalone: true,
    imports: [NgIf, NgxSkeletonLoaderModule, WorkshopJobsTableComponent, CustomerEquipmentSelectComponent, AsyncPipe]
})
export class WorkshopJobsListComponent {
  @Input() currency = 'GBP';
  canAdd$ = this.repairDocketStore.canAdd$;

  @Input() set docketId(id: number) {
    this.workshopJobListStore.setDocketId(id);
  }

  @Input() printFrame: any;

  customerId$ = this.repairDocketStore.docket$.pipe(
    filter((docket) => !!docket),
    map(({ customer_id }) => customer_id)
  );

  itemsWithParts$ = this.workshopJobListStore.itemsWithParts$;
  itemsLoading$ = this.workshopJobListStore.loading$;

  constructor(
    private repairDocketStore: RepairDocketStore,
    private workshopJobListStore: WorkshopJobListStore,
    private workshopJobService: WorkshopJobService
  ) {}

  print(jobId: number, download = false) {
    console.log('attempting to print', jobId, this.printFrame);
    this.workshopJobService
      .print(jobId)
      .pipe(
        takeUntil(this.workshopJobListStore.destroy$),
        map((response) =>
          URL.createObjectURL(base64ToBlob(response, 'application/pdf'))
        ),
        mergeMap((src) => {
          this.printFrame.src = src;
          return timer(500);
        })
      )
      .subscribe((response) => this.printFrame.contentWindow.print());
  }
}
